import Button from 'components/Button';
import {FC} from 'react';
import {t} from 'ttag';

type SupersendAddZipProps = {
    onClick?: () => void;
};

const SupersendAddZip: FC<SupersendAddZipProps> = ({onClick}) => (
    <Button
        className="h-[58px] rounded border border-grey-400 bg-grey-100 px-4 text-xs hover:bg-grey-200"
        icon="add"
        kind="custom"
        onClick={onClick}
    >
        {t`PDF/ZIP`}
    </Button>
);

export default SupersendAddZip;
